import { render, staticRenderFns } from "./StaffViewList.vue?vue&type=template&id=9dfb3b4c&scoped=true&"
import script from "./StaffViewList.vue?vue&type=script&lang=js&"
export * from "./StaffViewList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dfb3b4c",
  null
  
)

export default component.exports